export const SEED_SCHEMA_VERSION = 1;
//# sourceMappingURL=types.js.map